module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-06.b8cbe608.svg";